<template>
  <a-modal
    v-model="isVisible"
    @cancel="$emit('cancel')"
  >
    <div class="d-flex flex-column">
      <h5 class="text-center">{{ $t('sign_here') }}</h5>
      <div class="canvas-container">
        <div class="mx-auto signature-placeholder">
          <p>El dia de [Fecha de Firma]</p>
          <br><br><br><br>
          <p>Firma de [Nombre del Firmante]</p>
          <p>DNI: [DNI del Firmante]</p>
        </div>
        <canvas class="mx-auto border signature-pad" ref="canvas"></canvas>
      </div>
    </div>
    <template #footer>
      <a-button @click="onCancel">{{ $t('cancel') }}</a-button>
      <a-button v-if="instance" @click="instance.clear()">{{ $t('clear_signature') }}</a-button>
      <a-button v-if="instance" :disabled="instance.isEmpty()" type="primary" @click="onConfirm">{{ $t('confirm') }}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue'

import SignaturePad from 'signature_pad'

export default defineComponent({
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isVisible: false,

    handwritingSignature: null,
    instance: null
  }),

  methods: {
    onCancel () {
      this.isVisible = false
      this.$emit('cancel')
    },
    async onConfirm () {
      if (this.instance.isEmpty()) return
      const base64image = this.instance.toDataURL('image/jpeg')

      // await commonsApi.axiosPutWrapper('/users/upload-signature/' + this.documentForm.lumbreNextSigner.id, {
      //   signature: base64image
      // })
      this.$emit('confirm', base64image)

      this.isVisible = false
    },
    open () {
      this.isVisible = true

      this.$nextTick(() => {
        const canvas = this.$refs.canvas
        this.instance = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'rgb(0,15,85)'
        })
      })

      return new Promise((resolve, reject) => {
        this.$on('confirm', (event) => {
          resolve(event)
        })
        this.$on('cancel', () => {
          reject(new Error('cancel'))
        })
      })
    }
  },

  watch: {
    isVisible () {
      if (this.instance) {
        this.instance.clear()
      }
    }
  },

  mounted () {

  }
})
</script>

<style>
  .canvas-container {
    height: 150px;
    margin-left: 20%;
    position: relative;
  }
  .canvas-container > .signature-placeholder {
    position: absolute;
    max-width: 300px;
  }
  .canvas-container > .signature-placeholder > p {
    margin: 0;
    padding-left: 10px;
  }
  .canvas-container > .signature-pad {
    position: absolute;
    opacity: 0.7;
  }
</style>
